import styled from "styled-components";

export const Container = styled.span`
  height: fit-content;
  img {
    vertical-align: middle;
  }
`;
